export const getModalState = (modalName) => (state) => state.getIn(['app', 'modal', 'modalState', modalName]);
export const getModalStateProp = (modalName, propName) => (state) =>
    state.getIn(['app', 'modal', 'modalState', modalName, propName]);
